const styles = theme => ({
    filterContainer: {
        marginBottom: 16,
        padding: 16,
        width: "100%",
        background: 'transparent !important',
    },
    filterContainer: {
        marginBottom: 16,
        padding: 16,
        width: "100%",
        background: 'transparent !important',
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        padding: 20,
    },
    summaryBox: {
        padding: 20,
        background: '#c8be96',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        textAlign: 'center',
        fontFamily: 'cardiuma-M',
        color: '#333',
        minWidth: 120,
        margin: 8,
    },
    summaryTitle: {
        fontSize: 14,
        color: '#666',
        fontWeight: 500,
    },
    summaryValue: {
        fontSize: 22,
        color: '#131E2E',
        fontWeight: 700,
    },
    subGrid: {
        width: '100%',
        display: 'flex !important',
        justifyContent: 'flex-end !important'
    },

    button: {
        width: "90px !important",
        height: '40px !important',
        fontFamily: "cardiuma-M !important",
        fontSize: "12px !important",
        padding: '8px 10px 8px 10px !important',
        backgroundColor: '#f44748 !important',
        color: "#ffffff !important",
    },

    horizantalTablayout: {
        borderRadius: '15px !important',
        background: '#131E2E !important',
    },

    datepickerPopper: {
        transform: 'translate3d(0, 10px, 0) !important',
    },

    customDataGrid: {
        '& .MuiDataGrid-columnHeaders': {
            color: '#747474 !important',
            fontFamily: 'cardiuma-M !important',
            fontSize: '14px !important',
            fontWeight: '600 !important',
            lineHeight: '18px !important',
            borderRadius: '15px !important',

        },

        '& .MuiDataGrid-cell': {
            color: '#fff !important',
            fontFamily: 'cardiuma-regular !important',
            fontSize: '14px !important',
            fontStyle: 'normal',
            fontWeight: '400 !important',
            borderBottom: '1.5px solid black !important',
        },

        "& .MuiDataGrid-menuIconButton": {
            opacity: 1,
            color: "#fff !important"
        },

        "& .MuiDataGrid-sortIcon": {
            opacity: 1,
            color: "#fff !important",
        },

        '& .MuiDataGrid-withBorderColor': {
            borderColor: "none !important"
        },

        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-actions': {
            color: '#fff !important',
            fontFamily: 'cardiuma-regular !important',
            fontSize: '13px  !important',
            fontStyle: 'normal',
            fontWeight: '400  !important',
        },

        '& .MuiSelect-icon': {
            color: '#fff !important',
        },

        '& .MuiDataGrid-footerContainer': {
            border: 'none !important',
        },

        '& .MuiDataGrid-overlay': {
            backgroundColor: '#131E2E !important',
            color: '#ffffff !important',
            fontFamily: 'cardiuma-regular !important',
            fontSize: '14px  !important',
            fontStyle: 'normal',
            fontWeight: '400  !important',
        },

        '& .MuiDataGrid-filterIcon': {
            color: '#fff !important',
        }
    },
})

export default styles